/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingDtoApiResponse } from '../../models/setting-dto-api-response';

export interface GetSettingAsync$Plain$Params {
  id: number;
}

export function getSettingAsync$Plain(http: HttpClient, rootUrl: string, params: GetSettingAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getSettingAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingDtoApiResponse>;
    })
  );
}

getSettingAsync$Plain.PATH = '/api/settings/{id}';
